import { proxy } from "valtio";

type StatisticsStoreType = {
    salesModeCards: CardsModesType;
    salesSupportCards: CardsModesType;
    regulationModesCards: CardsModesType;
    products: StatisticsType;
    salesModes: StatisticsType;
    salesSupport: StatisticsType;
    services: StatisticsType;
    families: StatisticsType;
    subFamilies: StatisticsType;
    section: SectionType;
};

const store = proxy<StatisticsStoreType>({
    salesModeCards: {
        modes: [],
        amounts: [],
    },
    salesSupportCards: {
        modes: [],
        amounts: [],
    },
    regulationModesCards: {
        modes: [],
        amounts: [],
    },
    products: {
        top10: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
        all: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
    },
    salesModes: {
        top10: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
        all: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
    },
    salesSupport: {
        top10: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
        all: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
    },
    services: {
        top10: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
        all: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
    },
    families: {
        top10: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
        all: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
    },
    subFamilies: {
        top10: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
        all: {
            percentage: [],
            categories: [],
            histogram: [],
            csv: [],
            excel: [],
        },
    },
    section: "products",
});

export function setSalesModeCards(salesModeCards: CardsModesType) {
    store.salesModeCards = salesModeCards;
}

export function setSalesSupportCards(salesSupportCards: CardsModesType) {
    store.salesSupportCards = salesSupportCards;
}

export function setRegulationModesCards(regulationModesCards: CardsModesType) {
    store.regulationModesCards = regulationModesCards;
}

export function setTop10Percentage(data: any[], section: SectionType) {
    store[section].top10.percentage = JSON.parse(JSON.stringify(data));
}

export function setTop10Categories(data: any[], section: SectionType) {
    store[section].top10.categories = JSON.parse(JSON.stringify(data));
}

export function setTop10Histogram(data: any[], section: SectionType) {
    store[section].top10.histogram = JSON.parse(JSON.stringify(data));
}

export function setSubFamiliesTop10Csv(data: any[]) {
    store.subFamilies.top10.csv = JSON.parse(JSON.stringify(data));
}

export function setSalesModesTop10Csv(data: any[]) {
    store.salesModes.top10.csv = JSON.parse(JSON.stringify(data));
}

export function setSalesSupportTop10Csv(data: any[]) {
    store.salesSupport.top10.csv = JSON.parse(JSON.stringify(data));
}

export function setServicesTop10Csv(data: any[]) {
    store.services.top10.csv = JSON.parse(JSON.stringify(data));
}

export function setTop10FamiliesCsv(data: any[]) {
    store.families.top10.csv = JSON.parse(JSON.stringify(data));
}

export function setTop10ArticlesCsv(data: any[]) {
    store.products.top10.csv = JSON.parse(JSON.stringify(data));
}

export function setSalesModesTop10Excel(data: any[]) {
    store.salesModes.top10.excel = JSON.parse(JSON.stringify(data));
}

export function setSubFamiliesTop10Excel(data: any[]) {
    store.subFamilies.top10.excel = JSON.parse(JSON.stringify(data));
}

export function setSalesSupportTop10Excel(data: any[]) {
    store.salesSupport.top10.excel = JSON.parse(JSON.stringify(data));
}

export function setServicesTop10Excel(data: any[]) {
    store.services.top10.excel = JSON.parse(JSON.stringify(data));
}

export function setTop10FamiliesExcel(data: any[]) {
    store.families.top10.excel = JSON.parse(JSON.stringify(data));
}

export function setTop10ArticlesExcel(data: any[]) {
    store.products.top10.excel = JSON.parse(JSON.stringify(data));
}

export function setSalesModesAllPercentage(data: any[]) {
    store.salesModes.all.percentage = JSON.parse(JSON.stringify(data));
}

export function setAllCategories(data: any[], section: SectionType) {
    store[section].all.categories = JSON.parse(JSON.stringify(data));
}

export function setAllHistogram(data: any[], section: SectionType) {
    store[section].all.histogram = JSON.parse(JSON.stringify(data));
}

export function setCsv(data: any[], section: SectionType) {
    store[section].all.csv = JSON.parse(JSON.stringify(data));
}

export function setSubFamiliesCsv(data: any[]) {
    store.subFamilies.all.csv = JSON.parse(JSON.stringify(data));
}

export function setSalesSupportCsv(data: any[]) {
    store.salesSupport.all.csv = JSON.parse(JSON.stringify(data));
}

export function setServicesCsv(data: any[]) {
    store.services.all.csv = JSON.parse(JSON.stringify(data));
}

export function setSalesModesCsv(data: any[]) {
    store.salesModes.all.csv = JSON.parse(JSON.stringify(data));
}

export function setFamiliesCsv(data: any[]) {
    store.families.all.csv = JSON.parse(JSON.stringify(data));
}

export function setArticlesCsv(data: any[]) {
    store.products.all.csv = JSON.parse(JSON.stringify(data));
}

export function setExcel(data: any[], section: SectionType) {
    store[section].all.excel = JSON.parse(JSON.stringify(data));
}

export function setSubFamiliesExcel(data: any[]) {
    store.subFamilies.all.excel = JSON.parse(JSON.stringify(data));
}

export function setSalesSupportExcel(data: any[]) {
    store.salesSupport.all.excel = JSON.parse(JSON.stringify(data));
}

export function setServicesExcel(data: any[]) {
    store.services.all.excel = JSON.parse(JSON.stringify(data));
}

export function setSalesModesExcel(data: any[]) {
    store.salesModes.all.excel = JSON.parse(JSON.stringify(data));
}

export function setFamiliesExcel(data: any[]) {
    store.families.all.excel = JSON.parse(JSON.stringify(data));
}

export function setArticlesExcel(data: any[]) {
    store.products.all.excel = JSON.parse(JSON.stringify(data));
}

export function setSection(section: SectionType) {
    store.section = section;
}

export default store;
